import type { InviteEmailDeliveryStatus } from "./types";

export function inviteEmailStatusLabel(status: InviteEmailDeliveryStatus): string {
  switch (status) {
    case "sent":
      return "Email sent";
    case "failed":
      return "Email failed";
    case "not_attempted":
      return "Email not sent";
  }
}
